import { useTranslation } from "react-i18next";
import "./StatusBadge.css";

type StatusVariant = "positive" | "warning" | "negative" | "critical";

type StatusProps = {
    variant: StatusVariant;
    labelKey: string;
}

export function StatusBadge({ variant, labelKey }: StatusProps) {
    const { t } = useTranslation();
    return (
        <span className={`statusBadge statusBadge--${variant}`}>
            {t(`status.${labelKey}`)}
        </span>
    );
}